// Exportação CSV (separador ";" + BOM UTF-8, abre direto no Excel pt-BR).
export const downloadCsv = (filename: string, header: string[], rows: (string | number | null | undefined)[][]) => {
  const esc = (v: string | number | null | undefined) => {
    let s = v === null || v === undefined ? "" : String(v);
    // Injeção de fórmula (CSV injection): texto iniciado por = + - @ vira fórmula no Excel.
    // Prefixa com ' — exceto números (ex.: "-12,50" de csvNumber continua número).
    if (/^[=+\-@\t\r]/.test(s) && !/^-?\d[\d.,]*$/.test(s)) s = `'${s}`;
    return /[";\n\r]/.test(s) || s.startsWith("'") ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [header, ...rows].map((r) => r.map(esc).join(";")).join("\r\n");
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Número no formato pt-BR (vírgula decimal) para planilhas.
export const csvNumber = (v: number | null | undefined) =>
  v === null || v === undefined ? "" : v.toFixed(2).replace(".", ",");
